/**
 * 以 video 的真实播放状态同步 isVideoWindowVisible（play/pause/ended/emptied）
 * 抽离自 MusicPlayer.js
 */
import { useEffect } from 'react';

/**
 * @param {object} options
 * @param {object|null} options.currentMusic
 * @param {React.RefObject<HTMLVideoElement|null>} options.videoRef
 * @param {function(object): string|null} options.getVideoFilePath
 * @param {function(boolean): void} options.setIsVideoWindowVisible
 */
export function useVideoWindowVisibleSync({
  currentMusic,
  videoRef,
  getVideoFilePath,
  setIsVideoWindowVisible
}) {
  useEffect(() => {
    const hasVideo = currentMusic ? !!getVideoFilePath(currentMusic) : false;
    const video = videoRef.current;
    if (!hasVideo || !video) {
      setIsVideoWindowVisible(false);
      return;
    }

    const onPlay = () => setIsVideoWindowVisible(true);
    const onPause = () => setIsVideoWindowVisible(false);
    const onEnded = () => setIsVideoWindowVisible(false);
    const onEmptied = () => setIsVideoWindowVisible(false);

    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPause);
    video.addEventListener('ended', onEnded);
    video.addEventListener('emptied', onEmptied);

    setIsVideoWindowVisible(!video.paused && !video.ended);

    return () => {
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', onPause);
      video.removeEventListener('ended', onEnded);
      video.removeEventListener('emptied', onEmptied);
    };
  }, [currentMusic, videoRef, getVideoFilePath, setIsVideoWindowVisible]);
}
